// removed by extract-text-webpack-plugin
module.exports = {"cyan":"#63c2de","blue":"#2c6cba","indigo":"#6610f2","purple":"#6f42c1","pink":"#e83e8c","red":"#f86c6b","orange":"#f8cb00","yellow":"#ffc107","green":"#4dbd74"};
    if(module.hot) {
      // 1777962105351
      var cssReload = require("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./scss/style.scss
// module id = ./scss/style.scss
// module chunks = 3